"use strict";

var emojis = require("emoji-unicode-map");

module.exports = Object.keys(emojis.emoji);